__turbopack_context__.v({
  "action": "yBzkRW_action",
  "cancel": "yBzkRW_cancel",
  "close": "yBzkRW_close",
  "content": "yBzkRW_content",
  "description": "yBzkRW_description",
  "error": "yBzkRW_error",
  "icon": "yBzkRW_icon",
  "info": "yBzkRW_info",
  "spin": "yBzkRW_spin",
  "success": "yBzkRW_success",
  "title": "yBzkRW_title",
  "toast": "yBzkRW_toast",
  "warning": "yBzkRW_warning",
});
